import { AppAngularBaseClass } from "./services/app-angular-base";

/**
 * Base class for services that live in the core app layer.
 */
export class AppBaseCoreService extends AppAngularBaseClass {
  constructor() {
    super();
  }
}
